module.exports = __webpack_public_path__ + "static/img/i6.d32dfdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/iosMessageSet/i6.png
// module id = dJba
// module chunks = 0